export default function PillButton(props) {
    return (
        <div className="pill-button" data-index={props.index} onClick={props.onPillClick}>{props.title}</div>
    )
}